import React from 'react';
import { IntegrationDTO } from '../../api/useIntegrationsSettingsQuery';
import getImagePath from '../../../../../CommonUtils/getImagePath';
import { Link } from '../../../../../CommonComponents/OPL/Link/Link';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';

interface Props {
  integration: IntegrationDTO;
  website?: string;
  helpUrl?: string;
}

export const IntegrationInfo = ({ integration, website, helpUrl }: Props) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="flex-start"
      css={{ gap: '8px' }}
      mb="16"
    >
      <Box
        as="img"
        width="auto"
        maxWidth={34}
        maxHeight={34}
        src={getImagePath(`integrations_logos/${integration.Name}.png`)}
        alt="Firm logo"
      />

      {website && (
        <Link href={website} target="_blank" rel="noreferrer noopener" isExternal>
          Website
        </Link>
      )}

      {helpUrl && (
        <Link href={helpUrl} target="_blank" rel="noreferrer noopener" isExternal>
          Help
        </Link>
      )}
    </Box>
  );
};
